import { css } from '@emotion/react';

import { standardSpacing } from 'styles/global_defaults/scaffolding';
import { handheld, notDesktop } from 'styles/global_defaults/media-queries';

import FlipCard, { FlipCardData } from './flip-card';

type FlipCardGridProps = {
  cards: FlipCardData[];
};

const FlipCardGrid = ({ cards }: FlipCardGridProps) => {
  const styles = css`
    gap: ${standardSpacing}px;

    > * {
      flex: 0 1 calc((100% - ${standardSpacing * 2}px) / 3);
    }

    ${notDesktop(css`
      > * {
        flex-basis: calc((100% - ${standardSpacing}px) / 2);
      }
    `)}

    ${handheld(css`
      > * {
        flex-basis: 100%;
      }
    `)}
  `;

  return (
    <div className='d-flex flex-wrap justify-content-center' css={styles}>
      {cards.map((card) => (
        <FlipCard key={card.id} card={card} />
      ))}
    </div>
  );
};

export default FlipCardGrid;
